import React from 'react';
import TenantStatusBadge from './TenantStatusBadge';

const TenantDetailPanel = ({ tenant }) => {
  if (!tenant) {
    return <div className="rounded-xl border border-slate-800 bg-slate-900/70 p-4 text-sm text-slate-500">Pilih tenant untuk melihat detail.</div>;
  }

  return (
    <section className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
      <div className="flex items-center justify-between gap-3">
        <div>
          <h3 className="text-base font-semibold text-slate-100">Detail Tenant</h3>
          <div className="mt-1 text-xs text-slate-400">{tenant.tenantId}</div>
        </div>
        <TenantStatusBadge status={tenant.status} />
      </div>

      <div className="mt-3 grid gap-2 text-xs text-slate-300 md:grid-cols-2">
        <div className="rounded-lg border border-slate-800 bg-slate-950/60 px-3 py-2">Nama Tenant: <span className="text-slate-100">{tenant.tenantName}</span></div>
        <div className="rounded-lg border border-slate-800 bg-slate-950/60 px-3 py-2">Paket: <span className="text-slate-100">{tenant.plan}</span></div>
        <div className="rounded-lg border border-slate-800 bg-slate-950/60 px-3 py-2">Region: <span className="text-slate-100">{tenant.region || '-'}</span></div>
        <div className="rounded-lg border border-slate-800 bg-slate-950/60 px-3 py-2">Kontak: <span className="text-slate-100">{tenant.contactName || '-'}</span></div>
      </div>
    </section>
  );
};

export default TenantDetailPanel;
